import React from 'react'

import { HeaderContainer } from './styled'

const Header = props => {
  return <HeaderContainer>{props.children}</HeaderContainer>
}

export default Header
